
export default function About() {
  return (
    <section id="about" className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="bg-gray-700 rounded-2xl p-8 md:p-12 shadow-lg border border-gray-600">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Textual content */}
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Your Local Pest Control Experts
              </h2>
              <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                Young Guns Pest Control has been protecting homes and businesses in our community. We combine
                cutting‑edge technology with time‑tested methods to deliver results you can count on.
              </p>

              <div className="space-y-6 mb-10">
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-shield-check-line text-green-400 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-white mb-2">Licensed &amp; Certified</h3>
                    <p className="text-gray-300">
                      All of our Technicians are state‑licensed and undergo continuous training to stay up to date with the latest pest control technologies and standards.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-leaf-line text-green-400 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-white mb-2">Eco‑Friendly Solutions</h3>
                    <p className="text-gray-300">
                      We prioritize safe, environmentally responsible treatments that protect your family and pets while eliminating
                      pests.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-customer-service-line text-green-400 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-white mb-2">100% Satisfaction Guarantee</h3>
                    <p className="text-gray-300">
                      If you're not completely satisfied with our service, we'll return to re‑treat at no additional cost.
                    </p>
                  </div>
                </div>
              </div>

              <button className="bg-green-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-green-7
                transition-colors whitespace-nowrap cursor-pointer">
                Schedule Inspection
              </button>
            </div>

            {/* Image */}
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/6a9f81e4cca575d0550a7af793ac82ae.jpg"
                alt="Professional pest control service"
                className="rounded-2xl shadow-2xl object-cover w-full h-[600px] object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
